module.exports = __webpack_public_path__ + "img/instagramIcon.7dfda8f2.svg";